import { forwardRef } from 'react';
import { NavLink } from 'react-router-dom';

import { preserveConnectionSearchParams } from '../../services/connections';

const CustomNavLink = forwardRef(({ to, children, ...props }, ref) => (
    <NavLink ref={ref} to={{ pathname: to, search: preserveConnectionSearchParams(window.location.search) }} {...props}>
        {children}
    </NavLink>
));

export default CustomNavLink;
